import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../FormatAmount/FormatAmount";
import SvgComponent from "../../../SVGComponent";
import TickerAnimation from "../../../TickerAnimation";
/**
 * @typedef {("AccountNumber" | "Amount" | "Text")} type
 * @param {Object} props
 * @param {String} props.text - Header text
 * @param {type} props.type - Header type
 * @param {String} props.subtext - Sub text
 * @param {String} props.icon - url for gif/icon
 * @param {String} props.iconColor - color for gif/icon
 * @param {String} props.bgColor  color for gif/icon
 *
 * @returns {JSX.Element}
 */
const ListTextWithGif = ({ text, subtext, type, icon, iconColor, bgColor }) => {
  return (
    <div
      className="flex items-center justify-between w-full min-w-0 gap-x-gap-sm p-padding-sm relative"
      style={{ backgroundColor: bgColor ?? "inherit" }}
    >
      <div className="flex flex-col gap-y-gap-xs w-full min-w-0">
        <p className="text-font-xs text-text-primary truncate block overflow-hidden whitespace-nowrap min-w-0 font-normal">
          {type === "Amount" ? (
            <>
              INR <FormatAmount price={Number(text)} />
            </>
          ) : type === "AccountNumber" ? (
            standardAccountNumberFormat(text)
          ) : (
            <TickerAnimation text={text} />
          )}
        </p>

        <p className="text-font-xxs transform-none text-text-secondary">
          {subtext}
        </p>
      </div>

      {icon ? (
        <SvgComponent
          width="var(--icon-md)"
          height="var(--icon-md)"
          url={icon}
          color={iconColor}
        />
      ) : null}
    </div>
  );
};

export default ListTextWithGif;
